import { Routes, Route } from "react-router-dom";
import OpenBooster from "../components/Boosters/OpenBooster/OpenBooster";
import Login from "../pages/Login/Login";
import Profile, { ProfileViewMode } from "../pages/Profile/Pofile";
import Messages from "../pages/Messages/Messages";
import Explore from "../pages/Explore/Explore";
import Creator from "../pages/Creator/Creator";
import Register from "../pages/Register/Register";
import ForgotPassword from "../pages/ForgotPassword/ForgotPassword";
import { useAuth } from "../context/AuthProvider";
import LoginModal from "../components/Modal/LoginModal/LoginModal";
import CreateCards from "../components/Cards/CreateOrUpdateCards/CreateOrUpdateCards";
import CreateBooster from "../components/Boosters/CreateBooster/CreateBooster";
import UpdateBooster from "../components/Boosters/UpdateBooster/UpdateBooster";
import AddCardsToBooster from "../components/Boosters/AddCardsToBooster/AddCardsToBooster";
import Store from "../pages/Store/Store";
import { CreatorViewMode } from "../pages/Creator/Creator";
import UpdateProfile from "../components/Profile/UpdateProfile/UpdateProfile";
import Collection, { CollectionViewMode } from "../pages/Collection/Collection";
import { PreviewBooster } from "../components/Boosters/PreviewBooster/PreviewBooster";
import { Archive, ArchiveViewMode } from "../pages/Archive/Archive";
import Home from "../pages/Home/Home";
import { CGU } from "../pages/Static/Cgu";
import { CGV } from "../pages/Static/Cgv";
import { LegalMentions } from "../pages/Static/LegalMentions";
import ResetPassword from "../pages/ForgotPassword/ResetPassword";
import Orders from "../pages/Orders/Orders";
import { Admin } from "../pages/Admin/Admin";
import PrivacyPolicy from "../pages/Static/PrivacyPolicy";
// import Cart from "../pages/Cart/Cart";

// interface RoutesProps {
//   setShowLoginModal: (show: boolean) => void;
// }

export const PrivatesRoutes: React.FC = () => {
  const { user } = useAuth();

  return (
    <Routes>
      <Route path="/explore" element={<Explore />} />
      <Route path="/" element={user ? <Home /> : <Login />} />
      <Route path="/account/edit" element={<UpdateProfile />} />
      <Route element={<LoginModal />}>
        <Route path="/:boosterId/open" element={<OpenBooster />} />
        <Route path="/messages" element={<Messages />} />
        {/* <Route path="/creator" element={<Creator />} /> */}
        <Route path="/store" element={<Store />} />
        <Route path="/creator/cards/create" element={<CreateCards />} />
        <Route
          path="/creator/cards"
          element={<Creator viewModeValue={CreatorViewMode.cards} />}
        />
        <Route
          path="/archive/collector"
          element={<Archive viewModeValue={ArchiveViewMode.collector} />}
        />
        <Route
          path="/archive/creator"
          element={<Archive viewModeValue={ArchiveViewMode.creator} />}
        />
        <Route path="/archive" element={<Archive />} />
        <Route path="/creator/boosters/create" element={<CreateBooster />} />
        <Route
          path="/creator/boosters"
          element={<Creator viewModeValue={CreatorViewMode.boosters} />}
        />
        <Route
          path="/creator/boosters/:boosterId"
          element={<UpdateBooster />}
        />
        <Route
          path="/creator/boosters/:boosterId/cards"
          element={<AddCardsToBooster />}
        />
        <Route path="/boosters/:boosterId" element={<PreviewBooster />} />
        {/* <Route path="/posts/create" element={<CreateOrUpdatePost />} /> */}
        <Route
          path="/collection/cards"
          element={<Collection viewModeValue={CollectionViewMode.cards} />}
        />
        <Route
          path="/collection/boosters"
          element={<Collection viewModeValue={CollectionViewMode.boosters} />}
        />

        {/* <Route path="/Cart" element={<Cart />} /> */}
        <Route path="/transactions" element={<Orders />} />
        <Route path="/admin" element={<Admin />} />

        {/* <Route path="/creator/boosters/:boosterId/edit" element={<CreateBooster />} /> */}
      </Route>
    </Routes>
  );
};

export const PublicRoutes: React.FC = () => {
  const { user } = useAuth();

  return (
    <Routes>
      <Route path="/" element={!user && <Login />} />

      <Route path="/register" element={!user && <Register />} />
      <Route path="/forgot" element={!user && <ForgotPassword />} />
      <Route path="/forgot/reset" element={!user && <ResetPassword />} />
      <Route path="/profile/:username" element={<Profile />} />
      <Route
        path="/profile/:username/store"
        element={<Profile viewModeValue={ProfileViewMode.profileStore} />}
      />
      <Route
        path="/profile/:username/posts"
        element={<Profile viewModeValue={ProfileViewMode.posts} />}
      />
    </Routes>
  );
};

export const StaticPagesRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/CGU" element={<CGU />} />
      <Route path="/CGV" element={<CGV />} />
      <Route path="/Legal-mentions" element={<LegalMentions />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    </Routes>
  );
};

// const ProtectedRoute: React.FC<RoutesProps> = ({ setShowLoginModal }) => {
//   const { user } = useAuth();

//   if (!user) {
//     setShowLoginModal(true);
//     return <Navigate to="/" />;
//   }

//   return <Outlet />;
// };
